import {
    mapCrossCheckFieldName,
    mapCrossCheckMissingDataDecisionName,
    mapRuleDecisionName
} from '../rules_utils'

const CrossCheckRuleCard = (props) => {
    const { step, parameters, description } = props
    return (
        <div className="inbox__cell--left" style={{ paddingBottom: "10px" }}>
            <p className="data-field" style={{ marginBottom: "8px" }}>
                <span className="data-field__label dialogTitle">
                    <b>
                        {step}
                    </b>
                </span>
            </p>
            <div className="data-field" style={{ paddingBottom: '10px' }}>
                <span className="data-field__label">
                    Campos cruzados:
                </span>
                <ul>
                    {
                        parameters.map((parameter) => (
                            <li key={parameter.field} style={{ marginLeft: '30px', marginTop: '5px' }}>
                                <span className="data-field__value">
                                    {mapCrossCheckFieldName(parameter.field)} — se divergir: {mapRuleDecisionName(parameter.decision)}; se faltar dado: {mapCrossCheckMissingDataDecisionName(parameter.missing_data_decision)}
                                </span>
                            </li>
                        ))
                    }
                </ul>
            </div>
            <p>
                <span className="data-field__label">
                    Descrição:
                </span>
                <span className="data-field__value" style={{ paddingLeft: '5px' }}>
                    {description}
                </span>
            </p>
        </div>
    )
}

export default CrossCheckRuleCard
